import React, { useState } from 'react';
import '../assets/stylesheet/engagement.scss'

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, Title, Tooltip, Legend, BarElement, LinearScale } from 'chart.js';
import GetFormattedDateTime from '../utilities/getFormattedDateTime';
import { useNavigate } from 'react-router-dom';
import numeral from 'numeral';

function EngagementSummary(props) {
    return (
        <div className='card'>
            <div className='card-body p-0'>
                <div className='card-title d-flex align-items-center'>
                    <h3 className='row-2'>Engagement Summary</h3>
                </div>
                <div className='card-content p-2 pt-1'>
                    <div className='row g-2'>
                        <div className='col-6 text-center'>
                            <div className='eng-summary eng-summary-1'>
                                <div>
                                    <div className='service-name'>Requests</div>
                                    <div className='service-count'>{(props.engagementSummaryData.RequestsReceived)}</div>
                                    {/* <div className='service-count'>{formatNumber(props.engagementSummaryData.RequestsReceived)}</div> */}
                                </div>
                            </div>
                        </div>
                        <div className='col-6 text-center'>
                            <div className='eng-summary eng-summary-2'>
                                <div>
                                    <div className='service-name'>People Contacted</div>
                                    <div className='service-count'>{(props.engagementSummaryData.RequestsDelivered)}</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-6 text-center'>
                            <div className='eng-summary eng-summary-3'>
                                <div>
                                    <div className='service-name'>Responses</div>
                                    <div className='service-count'>{(props.engagementSummaryData.Responses)}</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-6 text-center'>
                            <div className='eng-summary eng-summary-4'>
                                <div>
                                    <div className='service-name'>Response Rate %</div>
                                    <div className='service-count'>{(numeral(props.engagementSummaryData.ResponseRate).format(0.00))}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

//==========================================================================================//
// Register necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function EngagementTrends(props) {
    const dataFromProps = props.data;
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter')||'')
    const navigate = useNavigate();
    const labels = dataFromProps.map(item =>
        GetFormattedDateTime(item.RequestDate));
    const requestsReceivedData = dataFromProps.map(item => item.RequestsReceived);
    const requestsDeliveredData = dataFromProps.map(item => item.RequestsDelivered);
    const responsesData = dataFromProps.map(item => item.Responses);
    const responseRateData = dataFromProps.map(item => parseInt(item.ResponseRate));
    const handleViewDetails = () => {
        const startData = JSON.stringify(props.from);
        const endDate = JSON.stringify(props.to);
        const selectedProject = JSON.stringify(props.pFilter);
        const quickFilter = JSON.stringify(props.qFilter);

        const encodedStartData = encodeURIComponent(startData);
        const encodedEndDate = encodeURIComponent(endDate);
        const encodedSelectedProject = encodeURIComponent(selectedProject);
        const encodedQuickFilter = encodeURIComponent(quickFilter);
        const query = `pf=${encodedSelectedProject}&qf=${encodedQuickFilter}&sd=${encodedStartData}&ed=${encodedEndDate}`;
        navigate(`/engagement?${query}`);
        window.location.reload();
    };
    const data = {
        labels: labels, // X-axis labels
        datasets: [
            {
                label: 'Response Rate (%)',
                type: 'line',
                data: responseRateData,
                fill: false,
                borderColor: '#333333',
                backgroundColor: '#333333',
                tension: 0.1,
                borderWidth: 2,
                yAxisID: 'y-axis-2',
            },
            {
                label: 'Requests',
                data: requestsReceivedData,
                backgroundColor: '#234b98',
                borderWidth: 0,
            },
            {
                label: 'People Contacted',
                data: requestsDeliveredData,
                backgroundColor: '#E85C0D',
                borderWidth: 0,
            },
            {
                label: 'Response',
                data: responsesData,
                backgroundColor: '#86aed6',
                borderWidth: 0,
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false, 
        plugins: {
            datalabels: {
                display: false,
            },
            legend: {
                display: true,
                position: 'bottom', 
                align: 'center', 
                labels: {
                    padding: (0, 15, 0, 10), 
                    boxWidth: 7, 
                    boxHeight: 7,
                    usePointStyle: true, 
                },
                title: {
                    display: true,
                    padding: -12,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
                    },
                },
            },
        },
        layout: {
            padding: {
                bottom: 0,
            },
        },
        scales: {
            x: {
                padding: 0,
                grid: {
                    display: false,
                },
                stacked: false,
                title: {
                    display: false,
                    text: 'Month'
                },
                ticks: {
                    beginAtZero: true,
                    padding: 0,
                    display: true,
                },
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    suggestedMax: 50,
                    suggestedMin: 1,
                    beginAtZero: true,
                    max: 120,
                    autoSkip: true,
                    lineHeight: 2,
                    callback: function (value) {
                        // return formatNumber(value);
                        return (value);
                    },
                },
                stacked: false,
                title: {
                    display: true,
                    text: 'Count'
                }
            },
            'y-axis-2': {
                grid: {
                    display: false,
                },
                // min: 0,
                // max: 105,
                type: 'linear',
                position: 'right',
                title: {
                    display: true,
                    text: 'Response Rate (%)',
                },
                beginAtZero: true,
                stacked: false, // Do not stack line chart
            },
          //---  min: 0,
        }
    };

    return (
        <div className='card'>
            <div className='card-body p-0'>
                <div className='card-title d-flex align-items-center'>
                    <h3>Engagement Summary</h3>
                    <span className='ms-auto'><a className={projectFilter != '' ? 'link-btn' : "disabled link-btn"}
                        onClick={handleViewDetails}>View Details</a></span>
                </div>
                    <div className='card-content p-2 pt-1 pb-0'>
                        <div style={{ height: '185px' }}>
                            <Bar data={data} options={options} />
                        </div>

                    </div>

                </div>
            </div>
    );

}
export { EngagementSummary, EngagementTrends };